export const fr = {
  // Navigation
  nav: {
    home: 'Accueil',
    services: 'Services',
    portfolio: 'Portfolio',
    process: 'Processus',
    about: 'À Propos',
    history: 'Notre Histoire',
    testimonials: 'Témoignages',
    faq: 'FAQ',
    contact: 'Contact'
  },

  // Hero Section
  hero: {
    tagline: 'ARCHITECTURE & DESIGN',
    title: 'CRÉER L\'EXCEPTION',
    subtitle: 'DANS CHAQUE DÉTAIL',
    description: 'Cabinet d\'architecture à Madagascar spécialisé dans la conception de maisons modernes et villas contemporaines à Antananarivo. Nous créons des espaces architecturaux uniques qui allient innovation, fonctionnalité et esthétique.',
    cta: {
      projects: 'DÉCOUVRIR NOS PROJETS',
      contact: 'NOUS CONTACTER'
    },
    vision: {
      title: 'NOTRE VISION',
      description: 'A Madagascar, nous transformons chaque projet résidentiel et commercial en une œuvre architecturale d\'exception à Antananarivo, en harmonisant créativité, construction durable et innovation.'
    }
  },

  // Stats
  stats: {
    projects: 'Projets Réalisés',
    experience: 'Années d\'Expérience',
    clients: 'Clients Satisfaits',
    locations: 'Lieux Couvertes'
  },

  // Services Section
  services: {
    title: 'NOS SERVICES',
    intro: 'Nous offrons une expertise complète en conception résidentielle, architecture commerciale et design d\'intérieur pour concrétiser vos projets les plus ambitieux.',
    description1: 'M.A CONCEPT accompagne particuliers, entreprises et promoteurs immobiliers dans toutes les phases de leurs projets architecturaux. De l\'étude de faisabilité initiale à la livraison finale, notre équipe d\'architectes diplômés met son savoir-faire au service de votre vision. Nous intervenons sur l\'ensemble du territoire malgache, avec une expertise particulière sur Antananarivo et la région d\'Analamanga.',
    description2: 'Notre approche intégrée combine architecture, design d\'intérieur et conseil en construction pour vous offrir un service complet et cohérent. Chaque projet bénéficie d\'une attention personnalisée et d\'une démarche créative adaptée à vos besoins spécifiques, votre budget et vos contraintes de terrain. Découvrez nos quatre domaines d\'expertise principaux :',
    items: [
      {
        title: 'Architecture Résidentielle',
        description: 'Conception de maisons et de résidences au style minimaliste, personnalisées selon les besoins de chaque client et intégrant des fonctionnalités conformes aux normes architecturales. Notre expertise couvre la conception de villas contemporaines, maisons individuelles, résidences de luxe et appartements modernes. Nous créons des espaces de vie qui reflètent votre personnalité tout en optimisant le confort, la luminosité naturelle et l\'efficacité énergétique. Chaque projet résidentiel bénéficie d\'une étude approfondie du terrain, de l\'orientation solaire et de l\'intégration paysagère pour garantir une harmonie parfaite avec l\'environnement malgache.',
        icon: '🏠',
        features: [
          'Plans sur mesure adaptés à votre mode de vie',
          'Design d\'intérieur et aménagement complet',
          'Supervision travaux et coordination des artisans',
          'Optimisation énergétique et développement durable'
        ]
      },
      {
        title: 'Architecture Commerciale',
        description: 'Création d\'espaces commerciaux innovants optimisés pour l\'expérience client et la performance commerciale. Notre équipe conçoit des bureaux modernes, centres commerciaux, showrooms, restaurants et espaces retail qui allient esthétique contemporaine et fonctionnalité optimale. Nous comprenons les enjeux de circulation, de visibilité et d\'attractivité propres aux espaces commerciaux. Chaque projet commercial est pensé pour maximiser le retour sur investissement tout en créant une identité architecturale forte qui distingue votre entreprise à Madagascar.',
        icon: '🏢',
        features: [
          'Centres commerciaux et galeries marchandes',
          'Bureaux et espaces de coworking modernes',
          'Espaces retail et showrooms attractifs',
          'Aménagement d\'espaces de restauration'
        ]
      },
      {
        title: 'Rénovation & Extension',
        description: 'Transformation et modernisation de bâtiments existants avec respect du patrimoine architectural malgache. Nous redonnons vie à votre propriété en préservant son caractère unique tout en intégrant les standards de confort contemporain. Que ce soit pour agrandir votre espace de vie, restructurer la distribution des pièces ou moderniser les installations, notre approche respectueuse valorise l\'existant. Nous gérons l\'ensemble du processus de rénovation, depuis les études de faisabilité structurelle jusqu\'à la livraison finale, en respectant les délais et budgets convenus.',
        icon: '🔧',
        features: [
          'Rénovation complète de bâtiments anciens',
          'Extensions et surélévations',
          'Mise aux normes énergétiques et sécurité',
          'Restructuration et redistribution d\'espaces'
        ]
      },
      {
        title: 'Consultation & Expertise',
        description: 'Accompagnement expert pour optimiser vos projets architecturaux et immobiliers à Madagascar. Notre service de consultation offre des conseils stratégiques à chaque étape de votre projet : analyse de terrain, étude de faisabilité technique et financière, optimisation des coûts de construction et conseils réglementaires. Nous vous aidons à prendre les bonnes décisions dès le début pour éviter les erreurs coûteuses. Notre expertise locale du marché malgache et notre connaissance des réglementations d\'urbanisme à Antananarivo constituent des atouts précieux pour la réussite de votre investissement immobilier.',
        icon: '📋',
        features: [
          'Étude de faisabilité et analyse de terrain',
          'Conseils techniques et choix des matériaux',
          'Suivi de projet et coordination générale',
          'Assistance administrative et permis de construire'
        ]
      },
      {
  title: 'Immobilier',
  description: 'Services immobiliers complets dédiés aux transactions foncières et immobilières à Madagascar. Nous accompagnons les particuliers et les investisseurs dans la vente de terrains, le traitement des dossiers administratifs et la préparation de projets immobiliers. Notre expertise garantit des transactions sécurisées, transparentes et bien structurées, depuis la vérification initiale des documents jusqu’au transfert final. À moyen terme, nos services incluront également la vente de bâtiments et de projets immobiliers clés en main.',
  icon: '🏞️',
  features: [
    'Vente de terrains et estimation foncière',
    'Traitement des dossiers administratifs et assistance juridique',
    'Vérification des titres fonciers et documents de propriété',
    'Future vente de bâtiments et projets immobiliers'
  ]
},
{
  title: 'Développement Web (Full-Stack)',
  description: 'Conception et développement d’applications web modernes, évolutives et sécurisées, adaptées aux besoins de votre activité. En tant que développeur full-stack, nous prenons en charge le développement front-end et back-end afin de fournir des solutions digitales complètes. Du site web institutionnel aux plateformes de gestion sur mesure, tableaux de bord et systèmes e-commerce, nous créons des applications performantes avec un fort accent sur l’ergonomie, la fiabilité et la maintenabilité. Chaque projet est pensé pour accompagner la croissance et la transformation digitale de votre entreprise.',
  icon: '💻',
  features: [
    'Sites web institutionnels et portfolios professionnels',
    'Applications web et tableaux de bord sur mesure',
    'Panneaux d’administration et gestion des utilisateurs',
    'Conception de bases de données, intégration d’API et maintenance'
  ]
}


    ]
  },

  // Portfolio Section
  portfolio: {
    title: 'PORTFOLIO',
    subtitle: 'Découvrez nos réalisations architecturales qui redéfinissent les espaces de vie et de travail.',
    projects: [
      {
        id: 1,
        title: 'Tour Résidentielle Contemporaine',
        description: 'Le ciel au crépuscule déploie une palette spectaculaire de violets et d\'oranges, avec des nuages striés qui captent la lumière déclinante. Au sol, l\'environnement se compose de massifs architecturaux en béton clair et d\'une végétation parsemée d\'arbres matures, le tout mis en valeur par un éclairage paysager qui souligne les volumes et les textures du paysage nocturne.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      },
      {
        id: 2,
        title: 'Villa Jardin avec Paysage Intégré',
        description: 'Le design extérieur du bâtiment, avec ses lignes épurées, ses grandes baies vitrées et l\'alternance de bardage bois et de parements sombres, établit une connexion visuelle et matérielle directe avec l\'aménagement extérieur. La conception du jardin, intégrant des zones engazonnées, des plantations florales violettes et un arbre majestueux entouré d\'une assise circulaire en bois, reflète et prolonge la palette de textures et de couleurs naturelles du bâti.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      },
      {
        id: 3,
        title: 'Maison Écologique à Énergie Solaire',
        description: 'Ce projet résidentiel moderne se caractérise par une architecture cubique contrastée, combinant un soubassement blanc et un bardage bois clair avec un étage supérieur gris anthracite sous un toit à faible pente doté de panneaux solaires. La disposition des fenêtres rectangulaires, de tailles variées et souvent en bandeau, maximise l\'apport de lumière naturelle tout en maintenant une esthétique épurée et contemporaine.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      },
      {
        id: 4,
        title: 'Complexe de Quatre Villas Jumelées',
        description: 'Ce concept architectural présente quatre unités résidentielles intégrées harmonieusement dans un paysage verdoyant, optimisant l\'orientation pour la lumière naturelle et les vues. Chaque unité combine des matériaux modernes tels que le bardage en bois clair et les façades sombres ou blanches, créant un contraste esthétique et une connexion visuelle forte avec la nature environnante.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      },
      {
        id: 5,
        title: 'Salle à Manger Contemporaine',
        description: 'Cet espace repas urbain incarne le design contemporain par son mariage de matériaux raffinés comme le marbre et le velours vert émeraude, une abondance de lumière naturelle filtrée, et des lignes épurées qui créent une atmosphère à la fois élégante et fonctionnelle.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      },
      {
        id: 6,
        title: 'Suite Parentale Urbaine',
        description: 'Cette chambre maîtresse urbaine combine une esthétique contemporaine avec des contrastes audacieux, où un mur d\'accent en bois foncé et des tons sombres sont équilibrés par des touches de lumière naturelle et une œuvre d\'art dynamique. L\'aménagement fonctionnel et le mobilier épuré créent un sanctuaire sophistiqué offrant des vues imprenables sur la ville.',
        year: '2025',
        location: 'Madagascar',
        category: 'Résidentiel'
      }
    ]
  },

  // About Section
  about: {
    title: 'À PROPOS DE M.A CONCEPT',
    paragraphs: [
      'Fondée sur une vision d\'excellence architecturale, M.A CONCEPT s\'impose comme référence dans la création d\'espaces innovants et durables à Madagascar. Notre cabinet d\'architecture basé à Antananarivo se distingue par une approche contemporaine et personnalisée de la conception architecturale.',
      'Notre approche unique combine créativité artistique, expertise technique et respect de l\'environnement pour donner vie à des projets qui marquent leur époque. Nous croyons fermement que l\'architecture doit répondre aux besoins fonctionnels tout en créant des émotions et en s\'intégrant harmonieusement dans le contexte malgache. Chaque ligne, chaque volume, chaque matériau est choisi avec soin pour créer des espaces qui transcendent les attentes.',
      'Chez M.A CONCEPT, nous ne construisons pas simplement des bâtiments, nous créons des environnements de vie qui améliorent le quotidien de leurs occupants. Notre équipe pluridisciplinaire d\'architectes et de designers travaille en étroite collaboration avec nos clients pour transformer leurs rêves en réalité architecturale. De la première esquisse à la remise des clés, nous accompagnons chaque projet avec passion et professionnalisme.',
      'Chaque projet est une opportunité d\'explorer de nouvelles possibilités architecturales, en plaçant l\'humain au cœur de nos préoccupations et en anticipant les besoins de demain. Nous intégrons dans nos conceptions les principes du développement durable, l\'optimisation énergétique et l\'utilisation de matériaux locaux lorsque c\'est possible. Notre connaissance approfondie du climat tropical de Madagascar nous permet de concevoir des bâtiments naturellement confortables, réduisant ainsi la dépendance aux systèmes de climatisation artificiels.',
      'Implantés au cœur d\'Antananarivo, nous rayonnons sur l\'ensemble du territoire malgache pour offrir nos services d\'architecture résidentielle, commerciale et de rénovation. Notre portfolio diversifié témoigne de notre capacité à relever tous les défis architecturaux, des villas contemporaines aux complexes résidentiels, des espaces commerciaux innovants aux projets de rénovation patrimoniale. La satisfaction de nos clients et la qualité de nos réalisations restent nos priorités absolues.'
    ],
    mission: {
      title: 'NOTRE MISSION',
      description: 'Créer des architectures exceptionnelles qui transforment la façon dont nous vivons, travaillons et interagissons avec notre environnement.'
    }
  },

  // Testimonials Section
  testimonials: {
    title: 'TÉMOIGNAGES',
    subtitle: 'La satisfaction de nos clients témoigne de notre engagement envers l\'excellence architecturale.',
    items: [
      {
        id: 1,
        name: 'Andriantsoa Rakoto',
        role: 'Propriétaire',
        comment: 'M.A CONCEPT a transformé notre vision en une réalité qui dépasse nos attentes. Leur approche professionnelle et créative est remarquable.',
        project: 'Projet Résidentiel'
      },
      {
        id: 2,
        name: 'Karim Alaoui',
        role: 'Directeur Commercial',
        comment: 'Un travail exceptionnel sur notre centre commercial. L\'équipe a su allier esthétique moderne et fonctionnalité optimale.',
        project: 'Centre Commercial Futuriste'
      },
      {
        id: 3,
        name: 'Fatima Zahra',
        role: 'Architecte Partenaire',
        comment: 'La collaboration avec M.A CONCEPT est toujours enrichissante. Leur vision innovante apporte une réelle valeur ajoutée à nos projets.',
        project: 'Résidence Écologique'
      }
    ]
  },

  // Contact Section
  contact: {
    title: 'CONTACTEZ-NOUS',
    subtitle: 'Prêt à concrétiser votre vision architecturale ? Discutons de votre projet et créons ensemble quelque chose d\'exceptionnel.',
    phone: 'TÉLÉPHONE',
    email: 'EMAIL',
    hours: {
      title: 'HORAIRES D\'OUVERTURE',
      weekdays: 'Lundi - Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      closed: 'Fermé'
    },
    form: {
      title: 'PARLEZ-NOUS DE VOTRE PROJET',
      name: 'NOM',
      namePlaceholder: 'Votre nom',
      emailLabel: 'EMAIL',
      emailPlaceholder: 'votre@email.com',
      phonePlaceholder: '+261 XX XXX XXXX',
      projectType: 'TYPE DE PROJET',
      projectTypePlaceholder: 'Sélectionner un type de projet',
      projectTypes: {
        villa: 'Villa / Maison individuelle',
        apartment: 'Appartement / Rénovation',
        commercial: 'Commerce / Bureau',
        industrial: 'Bâtiment industriel',
        mixed: 'Projet mixte',
        other: 'Autre'
      },
      budget: 'BUDGET ESTIMÉ',
      budgetPlaceholder: 'Sélectionner une fourchette',
      budgetRanges: {
        under500k: 'Moins de 500 000 Ar',
        '500k-1m': '500 000 - 1 000 000 Ar',
        '1m-2m': '1 000 000 - 2 000 000 Ar',
        '2m-5m': '2 000 000 - 5 000 000 Ar',
        over5m: 'Plus de 5 000 000 Ar'
      },
      description: 'DESCRIPTION DU PROJET',
      descriptionPlaceholder: 'Décrivez votre vision, vos besoins, contraintes techniques, délais souhaités...',
      submit: 'ENVOYER LA DEMANDE',
      submitting: 'ENVOI EN COURS...',
      success: 'Votre demande a été envoyée avec succès ! Notre équipe vous contactera sous 24h.',
      error: 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer ou nous contacter directement au +261349838111.',
      consent: 'En soumettant ce formulaire, vous acceptez d\'être contacté par M.A CONCEPT concernant votre projet architectural.'
    }
  },

  // Footer
  footer: {
    description: 'Cabinet d\'architecture malgache à Antananarivo spécialisé dans la création de maisons modernes, villas contemporaines et espaces commerciaux innovants qui redéfinissent l\'art de vivre à Madagascar.',
    services: 'SERVICES',
    contactTitle: 'CONTACT',
    phone: 'Téléphone',
    email: 'Email',
    legal: {
      rights: '© 2025 M.A CONCEPT. Tous droits réservés.',
      legalNotice: 'Mentions Légales',
      privacy: 'Politique de Confidentialité',
      terms: 'CGU'
    },
    footerServices: [
      {
        id: 'architecture-residentielle',
        title: 'Architecture Résidentielle',
        description: 'Conception de maisons modernes et villas contemporaines personnalisées. Nous créons des espaces de vie uniques qui reflètent votre personnalité tout en optimisant confort et efficacité énergétique.'
      },
      {
        id: 'architecture-commerciale',
        title: 'Architecture Commerciale',
        description: 'Création d\'espaces commerciaux innovants : bureaux modernes, centres commerciaux, showrooms et restaurants qui maximisent votre retour sur investissement.'
      },
      {
        id: 'renovation-extension',
        title: 'Rénovation & Extension',
        description: 'Transformation et modernisation de bâtiments existants. Nous redonnons vie à votre propriété en préservant son caractère unique tout en intégrant les standards contemporains.'
      },
      {
        id: 'design-interieur',
        title: 'Design d\'Intérieur',
        description: 'Aménagement et décoration d\'intérieur sur mesure. Nous créons des ambiances uniques et fonctionnelles qui transforment vos espaces de vie en lieux d\'exception.'
      },
      {
        id: 'consultation-technique',
        title: 'Consultation Technique',
        description: 'Conseils d\'experts pour optimiser vos projets : étude de faisabilité, analyse de terrain, choix des matériaux et assistance administrative.'
      },
      {
        id: 'suivi-chantier',
        title: 'Suivi de Chantier',
        description: 'Coordination complète de votre projet de construction : supervision des travaux, gestion des artisans, contrôle qualité et respect des délais.'
      }
    ]
  },

  // Team
  team: [
    {
      id: 1,
      name: 'Ny Antsa',
      profession: 'Urbaniste',
      specialization: 'Architecture & Développement Durable'
    },
    {
      id: 2,
      name: 'Sariaka',
      profession: 'Artiste',
      specialization: 'Du rendu 3D'
    },
    {
      id: 3,
      name: 'Clément',
      profession: 'Développeur',
      specialization: 'Full Stack'
    }
  ],

  // Process Section
  process: {
    title: 'NOTRE PROCESSUS',
    subtitle: 'De l\'idée à la réalisation, nous vous accompagnons à chaque étape de votre projet architectural.',
    steps: [
      {
        number: 1,
        title: 'Consultation',
        description: 'Rencontre pour comprendre vos besoins, votre terrain et définir votre budget.'
      },
      {
        number: 2,
        title: 'Étude & Esquisses',
        description: 'Analyse du site et réalisation des premières esquisses de votre projet.'
      },
      {
        number: 3,
        title: 'Plans Techniques',
        description: 'Conception des plans détaillés 2D et modélisation 3D complète.'
      },
      {
        number: 4,
        title: 'Rendus 3D',
        description: 'Visualisations photoréalistes pour vous projeter dans votre futur espace.'
      },
      {
        number: 5,
        title: 'Permis de Construire',
        description: 'Préparation des documents et accompagnement dans les démarches administratives.'
      },
      {
        number: 6,
        title: 'Suivi de Chantier',
        description: 'Coordination des travaux et contrôle qualité jusqu\'à la livraison.'
      }
    ]
  },

  // FAQ Section
  faq: {
    title: 'QUESTIONS FRÉQUENTES',
    subtitle: 'Retrouvez les réponses aux questions les plus courantes sur nos services d\'architecture.',
    items: [
      {
        question: 'Quels services proposez-vous exactement ?',
        answer: 'Nous offrons une gamme complète de services : conception architecturale (plans techniques et modélisation 3D), réalisation de rendus photoréalistes, assistance pour les permis de construire, et suivi de chantier. Nous vous accompagnons de la première esquisse jusqu\'à la livraison de votre projet.'
      },
      {
        question: 'Comment se déroule la conception d\'un projet ?',
        answer: 'Tout commence par une rencontre pour comprendre vos besoins, votre terrain et votre budget. Nous réalisons ensuite les premières esquisses, puis après validation, nous passons aux plans techniques détaillés et aux visualisations 3D. Vous validez chaque étape avant de poursuivre, garantissant un résultat conforme à vos attentes.'
      },
      {
        question: 'Fournissez-vous des plans 3D et des rendus réalistes ?',
        answer: 'Oui, nous réalisons des modélisations 3D complètes et des rendus photoréalistes de haute qualité grâce à nos logiciels professionnels de conception architecturale. Ces visuels vous permettent de vous projeter dans votre futur espace et d\'ajuster les détails avant la construction.'
      },
      {
        question: 'Combien de temps faut-il pour obtenir les plans ?',
        answer: 'Les délais dépendent de la complexité du projet. Pour une maison individuelle, comptez environ 2 à 4 semaines pour les esquisses et plans préliminaires, puis 4 à 8 semaines pour les plans d\'exécution complets. Nous définissons ensemble un planning réaliste dès le départ.'
      },
      {
        question: 'Gérez-vous les démarches pour le permis de construire ?',
        answer: 'Oui, nous préparons tous les documents techniques nécessaires : plans, coupes, façades, et notices descriptives. Nous pouvons également vous accompagner dans les démarches administratives auprès des autorités compétentes à Madagascar.'
      },
      {
        question: 'Proposez-vous un suivi de chantier ?',
        answer: 'Absolument. Le suivi de chantier fait partie de nos services. Nous assurons la coordination des différents corps de métier, vérifions la conformité des travaux avec les plans, et organisons des visites régulières pour garantir la qualité et le respect des délais de votre construction.'
      },
      {
        question: 'Quel est le coût de vos prestations ?',
        answer: 'Nos tarifs varient selon la nature et l\'ampleur du projet. Nous proposons généralement un forfait pour la conception (plans + 3D) et un pourcentage du coût des travaux pour le suivi de chantier. Contactez-nous pour recevoir un devis personnalisé gratuit.'
      },
      {
        question: 'Travaillez-vous sur des projets de rénovation ?',
        answer: 'Oui, nous intervenons sur les constructions neuves comme sur les rénovations et extensions. Pour une rénovation, nous commençons par un relevé précis de l\'existant afin de proposer des solutions adaptées à vos besoins tout en respectant les contraintes du bâtiment.'
      }
    ]
  },

  // History Section
  history: {
    title: 'NOTRE HISTOIRE',
    milestones: [
      {
        year: '2023',
        title: 'Création de M.A Concept',
        description: 'M.A Concept voit le jour avec une vision ambitieuse : offrir des services architecturaux modernes, innovants et adaptés aux besoins de chaque client. Dès ses débuts, l\'entreprise se distingue par sa créativité, son sérieux et son engagement envers la qualité.',
        features: []
      },
      {
        year: '2025',
        title: 'Collaborations Stratégiques',
        description: 'M.A Concept franchit une nouvelle étape grâce à ses collaborations avec MIRALUX et SIGMA Technologie, deux acteurs majeurs situés sur l\'île de La Réunion. Ces partenariats renforcent notre expertise dans plusieurs domaines clés et nous permettent d\'intégrer des solutions technologiques avancées dans nos projets, pour offrir à nos clients des espaces plus intelligents, plus sûrs et plus performants.',
        features: [
          'Domotique',
          'Sécurité',
          'Audiovisuel',
          'Éclairage'
        ]
      },
      {
        year: '2026',
        title: 'Expansion dans le domaine de l’immobilier',
        description: 'En 2026, M.A Concept  élargit son champ d’activité en intégrant le secteur de l’immobilier. En complément de la conception architecturale et du développement de projets, l’entreprise propose désormais des services immobiliers incluant la vente de terrains, les transactions immobilières et le conseil professionnel. Cette évolution stratégique permet d’offrir des solutions complètes, depuis l’acquisition foncière et la conception architecturale jusqu’à la valorisation et la mise sur le marché des biens.',
      }

    ]
  },

  // Common
  common: {
    required: '*',
    loading: 'Chargement...'
  }
};
